import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CreateRoleLayer from "../components/CreateRoleLayer";


import { useLocation } from "react-router-dom";


const CreateRolePage = () => {
  const location = useLocation();
  const editRole = location.state?.editRole;
  const isEditMode = !!editRole;

  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb
          title={isEditMode ? "Edit Role" : "Create Role"}
          header={isEditMode ? "Edit Role" : "Create Role"}
        />

        {/* Create Role */}
        <CreateRoleLayer />


      </MasterLayout>

    </>
  );
};

export default CreateRolePage;
